import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import account from './account.json';
import cms from './cms.json';
import component from './component.json';
import content from './content.json';
import dashboard from './dashboard.json';
import group from './group.json';
import mdx from './mdx.json';
import modal from './modal.json';
import order from './order.json';
import profile from './profile.json';
import storage from './storage.json';
import tv from './tv.json';


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: localStorage.i18nextLng || (location.hostname === 'mediabaza.net' ? 'en' : (navigator.language?.slice(0, 2) || 'ru')), // navigator.language,
        // we init with resources
        resources: {
            en: {
                account: account.en,
                cms: cms.en,
                content: content.en,
                component: component.en,
                dashboard: dashboard.en,
                profile: profile.en,
                modal: modal.en,
                tv: tv.en,
                group: group.en,
                order: order.en,
                storage: storage.en,
                translations: {
                    "TGBOT": "Telegram bot",
                    "Show access keys": "Show access keys",
                    "Access keys": "Access keys",
                    "Access key": "Access key",
                    "Key": "Key",
                    "Object": "Object",
                    "SAVE_KEYS": "Please save the key pair for access from external systems before closing this window",
                    "KEYS_INFO": "Здесь будет инструкция по применению",
                    "Occupied": "Occupied",
                    "Size": "Size",
                    "Sorting": "Sorting",
                    "People": "People",
                    "Copy": "Copy",
                    "Copied": "Copied",
                    "Done": "Done",
                    "In progress": "In progress",
                    "In line": "In line",
                    "Disk": "Disk",
                    'Value': 'Value',
                    "Action": "Action",
                    "Filename": "Filename",
                    "Compressed": "Compressed",
                    "Details": "Details",
                    "Today": "Today",
                    "Yesterday": "Yesterday",
                    "Birthday": "Birthday",
                    "Pin": "Pin",
                    "Unpin": "Unpin",
                    "On": "On",
                    "OFF": "Off",
                    "Close": "Close",
                    "Clean": "Clean",
                    "Apply": "Apply",
                    "Filter": "Filter",
                    "Filters": "Filters",
                    "Deals": "Deals",
                    "Registry": "Registry",
                    "Portfolio": "Portfolio",
                    "Partners": "Partners",
                    "History": "History",
                    "Contract": "Contract",
                    "Contracts": "Contracts",
                    "Contract number": "Contract number",
                    "Contract term": "Contract term",
                    "Reliable partner": "Reliable partner",
                    "New contract": "New contract",
                    "New document": "New document",
                    "Edit document": "Edit document",
                    "Load document": "Load document",
                    "Document": "Document",
                    "Document number": "Document number",
                    "Document term": "Document term",
                    "Linked documents": "Linked documents",
                    "Initiator": "Initiator",
                    "See all": "See all",
                    "Other events": "Other events",
                    "Other promotions": "Other promotions",
                    "All news": "All news",
                    "All polls": "All votes",
                    "All adverts": "All announcements",
                    "until": "until",
                    "Take part": "Take part",
                    "We recommend": "We recommend",
                    "Term": "Term",
                    "Archive": "Archive",
                    "Number": "Number",
                    "Service type": "Service type",
                    "Product type": "Product type",
                    "Product": "Product",
                    "Products": "Products",
                    "Matrix": "Matrix",
                    "Parameters": "Parameters",
                    "TV signal": "TV signal",
                    "Redact": "Edit",
                    "Age": "Age",
                    "Agerestriction": "Agerestriction",
                    "provider_owner": "Provider owner",
                    "consumer_auditor": "Consumer auditor",
                    "Enter to account": "Enter to account",
                    'Accounts': 'Accounts',
                    'My accounts': 'My accounts',
                    'Ask our support': 'Ask our support',
                    'Agreement': 'Agreement',
                    'Mediabaza': 'Mediabaza',
                    'MM': 'MassMedia catalog',
                    'Scope of rights': 'Scope of rights',
                    'Broadcasting area': 'Broadcasting area',
                    'Russia': 'Russia',
                    'Worldwide': 'Worldwide',
                    'Environment': 'Environment',
                    'Cable broadcasting': 'Cable broadcasting',
                    'Distribution environment': 'Distribution environment',
                    'Comment': 'Comment',
                    'comment': 'comment',
                    'Next': 'Next',
                    'Cancel': 'Cancel',
                    'Transcode': 'Transcode',
                    'Transcoded': 'Transcoded',
                    'Transcoding': 'Transcoding',
                    'Download transcoded': 'Download transcoded',
                    'Enter a techinfo': 'Enter a techinfo',
                    'Download all': 'Download all',
                    'email': 'email',
                    'Email': 'Email',
                    'Enter Email': 'Enter Email',
                    'Enter password': 'Enter password',
                    'Passwords do NOT match': 'Passwords do NOT match',
                    'a marketplace for video content, TV channels, and media services': 'a marketplace for video content, TV channels, and media services',
                    'Everything you need for content operations—all in one digital hub: from search and acquisition to delivery, rights management, and legal compliance.': 'Everything you need for content operations—all in one digital hub: from search and acquisition to delivery, rights management, and legal compliance.',
                    'Marketplace <br>to buy and sell media content': 'Marketplace <br>to buy and sell media content',
                    'Unique content': 'Unique content',
                    'Piracy Protection': 'Piracy protection',
                    'Free access to basic functions': 'Free access to basic functions',
                    'Affordable price': 'Affordable price',
                    'User friendly support': 'User friendly support',
                    'Content Search': 'Content Search',
                    'Unique catalog of downloadable content and TV channels for easy search and order': 'Unique catalog of downloadable content for easy search and order',
                    'Licensing Rights': 'Licensing Rights',
                    'Safe transactions between a licensor and a licensee. Highly automated processes': 'Safe transactions between a licensor and a licensee. Highly automated processes',
                    'Delivery': 'Delivery',
                    'Reliable content delivery of heavy-loaded video content in innovative formats VR, 4К, 8К, HDR': 'Reliable content delivery of heavy-loaded video content in innovative formats VR, 4К, 8К, HDR',
                    'Updating': 'Updating',
                    '<br />catalog of streaming services': '<br />catalog of streaming services',
                    'Distributing': 'Distributing',
                    '<br />ad-videos to the regional network': '<br />ad-videos to the regional network',
                    'Uploading': 'Uploading',
                    'Card files': 'Card files',
                    'Show on Disk': 'Show on Disk',
                    'movies to multiplex movie theaters': 'movies to multiplex movie theaters',
                    'Setting content': 'Setting content',
                    'for TV channels': 'for TV channels',
                    'Increase the efficiency of your business with the help of Mediabase if your business is': 'Increase the efficiency of your business with the help of Mediabase if your business is',
                    'Cloud platform to increase the efficiency of interactions between professional participants in the media market': 'Cloud platform to increase the efficiency of interactions between professional participants in the media market',
                    'For Sellers': 'For Sellers',
                    'Sell Сontent': 'Sell Сontent',
                    'Become a seller': 'Become a seller',
                    'Single entry point to reach your customers': 'Single entry point to reach your customers',
                    'Safe storage of content archive': 'Safe storage of content archive',
                    'Fast delivery of heavy 4K content': 'Fast delivery of heavy 4K content',
                    'Content distribution control': 'Content distribution control',
                    'Lead generation': 'Lead generation',
                    'For Buyers': 'For Buyers',
                    'Buy Сontent': 'Buy content',
                    'Become a buyer': 'Become a buyer',
                    'Easy to use catalog to search for content from all over the world': 'Easy to use catalog to search for content from all over the&nbsp;world',
                    'Easy content ordering': 'Easy content ordering',
                    'Video transcoding into any format': 'Video transcoding into any format',
                    'Downloading using speed protocol': 'Downloading using speed protocol',
                    'Metadata is included': 'Metadata is included',
                    'Get free access to try out the platform': 'Get free access to try out the platform',
                    'What Mediabaza Offers': 'What Mediabaza Offers',
                    'Exclusive Deals & Promotions': 'Exclusive Deals & Promotions',
                    'Solutions for TV Channels': 'Solutions for TV Channels',
                    'Additional services of Mediabase': 'Additional services of Mediabase',
                    'Subtitling, AI-powered translation, video content verification for compliance with legislation': 'Subtitling, AI-powered translation, video content verification for compliance with legislation',
                    'Get Started Today': 'Get Started Today',
                    'Sign up at': 'Sign up at <1>mediabaza.ru</1> — gain instant access to content, tools, and conditions designed for your success.',
                    'Powered by MSK-IX — a leading internet infrastructure provider with 30 years of industry trust and expertise.': 'Powered by MSK-IX — a leading internet infrastructure provider with 30 years of industry trust and expertise.',
                    'Get Access': 'Get Access',
                    'Feedback': 'Feedback',
                    'Contacts': 'Contacts',
                    'To showcase': 'To showcase',
                    'To tv': 'To tv card',
                    'TV': 'TV channel',
                    'To adverts list': 'To announcements',
                    'To news list': 'To news list',
                    'To promo list': 'To special offers',
                    'To polls list': 'To votes list',
                    'To many requests': 'To many requests',
                    'Re-vote': 'Re-vote',
                    'Color': 'Color',
                    'News': 'News',
                    'No news': 'No news',
                    'Download': 'Download',
                    'Downloading': 'Downloading',
                    'Download metadata': 'Download metadata',
                    'Metadata': 'Metadata',
                    'Download again': 'Download again',
                    'Create': 'Create',
                    'Send': 'Send',
                    'Content unit': 'Content unit',
                    'TV (content)': 'Телеканал (контент)',
                    'TV channel': 'TV channel',
                    'TV channels': 'TV channels',
                    'Video content': 'Video content',
                    'Common content': 'Common content',
                    'Vertical content': 'Vertical content',
                    'Films': 'Films',
                    'Ad': 'Promotion',
                    'Finished': 'Finished',
                    'The event has ended': 'The event has ended',
                    'Vote': 'Vote',
                    'Votes': 'Votes',
                    'votes': 'votes',
                    'Series2': 'Series',
                    'Create a new card': 'Create new card',
                    'Create a content unit': 'Create content unit',
                    'Create a tv unit': 'Create TV channel unit',
                    'Create a service unit': 'Create a service unit',
                    '+ Upload files': '+ Upload files',
                    'Enter a title': 'Enter a title',
                    'Enter a s3 path': 'Enter a s3 path',
                    'S3 path': 'Path on Disk',
                    'S3 name': 'S3 name',
                    'Revert': 'Revert',
                    'TV channel name': 'TV channel name',
                    'Enter a name': 'Enter a name',
                    'Enter a price': 'Enter a price',
                    'Enter license number': 'Enter license number',
                    'Title': 'Title',
                    'optional': 'optional',
                    'required': 'required',
                    'Load cover': 'Load cover',
                    'Load logo or cover': 'Load logo or cover',
                    'Load demo': 'Load demo',
                    'Choose': 'Choose',
                    'Choose a sources': 'Choose a sources',
                    'Choose a tvchannel': 'Choose a tvchannel',
                    'Choose a agerestriction': 'Choose a agerestriction',
                    'Choose a task': 'Choose a task',
                    'Choose a category': 'Choose a category',
                    'Fill in the information': 'Fill in the information',
                    'Choose a country': 'Choose a country',
                    'Choose a language': 'Choose a language',
                    'Choose a genre': 'Choose a genre',
                    'Choose a collection': 'Choose a collection',
                    'Choose a provider': 'Choose a provider',
                    'Country of Origin': 'Country of Origin',
                    'Voice language': 'Voice language',
                    'Production': 'Production',
                    'Broadcast': 'Broadcast',
                    'Broadcasting': 'Broadcasting',
                    'Watch TV channel broadcast': 'Watch TV channel broadcast',
                    'Demo video': 'Demo video',
                    'Genre': 'Genre',
                    'Subtitle': 'Subtitle',
                    'Choose a year': 'Choose a year',
                    'Year of issue': 'Year of issue',
                    'Description': 'Description',
                    'Enter a description': 'Enter a description',
                    'Quality': 'Quality',
                    'Choose a quality': 'Choose a quality',
                    'Choose an accessibility mode': 'Choose an accessibility mode',
                    'To view': 'To view',
                    'To download': 'To download',
                    'Choose a role': 'Choose a role',
                    'Choose a specialization': 'Choose a specialization',
                    'Choose a customers': 'Choose a customers',
                    'Choose a customers to view': 'Choose a customers to view',
                    'Choose a customers to download': 'Choose a customers to download',
                    'Offer consumers': 'Offer consumers',
                    'All': 'All',
                    'List': 'List',
                    'Nobody': 'Nobody',
                    'from': 'from',
                    'Subject': 'Subject',
                    'Availability': 'Availability',
                    'Count of orders': 'Count of orders',
                    'Count of downloads': 'Count of downloads',
                    'Fill in': 'Fill in',
                    'Filling': 'Filling',
                    'Filled out': 'Fill out',
                    'Checked': 'Checked',
                    'In favorites': 'In favorites',
                    'New': 'New',
                    'Blocked by moderator': 'Blocked by moderator',
                    'Access Denied.': 'Access denied',
                    'Available to group': 'Available to group',
                    'Available to everyone': 'Available to everyone',
                    'Available to VIP': 'Available to VIP',
                    'Lock': 'Lock',
                    'By date': 'By date',
                    'By name': 'By name',
                    'By checked': 'By checked',
                    'for': 'for',
                    'For all': 'For all',
                    'For VIP': 'For VIP',
                    'For group': 'For group',
                    'For no one': 'For no one',
                    'Category of rights': 'Category of rights',
                    'Search': 'Search',
                    'Search by partners': 'Search by partners',
                    'Search by registry': 'Search by registry',
                    'Search by name': 'Search by name',
                    'Search by name and supplier': 'Search by name and supplier',
                    'Search by guests': 'Search by guests',
                    'Search by accounts': 'Search by accounts',
                    'Search by catalog': 'Search by catalog',
                    'Search by requests and content': 'Search by requests and content',
                    'Search by object': 'Search by object',
                    'Search by promo': 'Search by promo',
                    'Promocode': 'Promocode',
                    'You do not have a valid account': 'You do not have a valid account',
                    'Can download': 'Can download',
                    'Can view': 'Can view',
                    'Can downloads': 'Can downloads',
                    'Source': 'Source',
                    'Sources': 'Sources',
                    'Order several': 'Order several',
                    'Option': 'Option',
                    'Options': 'Options',
                    'Deffered': 'Deffered',
                    'Count': 'Count',
                    'Custom date range': 'Custom date range',
                    'since': 'since',
                    'Since': 'Since',
                    'till': 'till',
                    'Till': 'Till',
                    'Drag file here': 'Drag file here',
                    'Drag files here': 'Drag files here',
                    'or select on computer': 'or select on computer',
                    'Supported file formats': 'Supported file formats',
                    'Supported file formats mp4, webm и ogg': 'Supported file formats mp4, webm и ogg',
                    'Page not found': 'Page not found',
                    'You can go ': 'You can go ',
                    'back': 'back',
                    ' or go to the ': ' or go to the ',
                    'showcase': 'showcase',
                    'Sign': 'Sign',
                    'Log In': 'Log In',
                    'Sign in': 'Log In',
                    'Sign Up': 'Sign Up',
                    'Forgot password': 'Forgot password',
                    'Recover password': 'Recover password',
                    'Forgot your password': 'Forgot your password',
                    'Register': 'Register',
                    'The action is available for registered users': 'The action is available for registered users',
                    'Voting is available only to registered users': 'Voting is available only to registered users',
                    'Tools': 'Tools',
                    'Instructions': 'Instructions',
                    'Load into xls': 'Load into xls',
                    'Load into csv': 'Load into csv',
                    'Save as': 'Save as',
                    'Title is required': 'Title is required',
                    'Image is required': 'Image is required',
                    'This field is required': 'This field is required',
                    'Message is required': 'Message is required',
                    'Email is required': 'Email is required',
                    'Code is required': 'Code is required',
                    'Invalid code': 'Invalid code',
                    'Download the file in pdf format': 'Download the file in pdf format',
                    'File': 'File',
                    'Folder': 'Folder',
                    'files': 'files',
                    'Files': 'Files',
                    'used': 'used',
                    'Load error': 'Load error',
                    'Delete request error': 'Delete request error',
                    'Change permissions error': 'Change permissions error',
                    'Save failed': 'Save failed',
                    'Delete failed': 'Delete failed',
                    'This password is too short. It must contain at least 8 characters.': 'This password is too short. It must contain at least 8 characters.',
                    'This password is too common.': 'This password is too common.',
                    'Delivered': 'Delivered',
                    'Handled': 'Handled',
                    'MY': 'MY',
                    'ALL': 'ALL',
                    'CUSTOM': 'CUSTOM',
                    'NOTHING': 'NOTHING',
                    'Notification list': 'Notification list',
                    'View Permissions': 'View Permissions',
                    'Download Permissions': 'Download Permissions',
                    'Novelty': 'Novelty',
                    'Admin dashboard': 'Admin dashboard',
                    'Consumer dashboard': 'Consumer dashboard',
                    'Provider dashboard': 'Provider dashboard',
                    'Guest dashboard': 'Guest dashboard',
                    'Add': 'Add',
                    'Edit': 'Edit',
                    'Delete': 'Delete',
                    'Deleted': 'Deleted',
                    'Success': 'Success',
                    'Error': 'Error',
                    'Save': 'Save',
                    'Edit': 'Edit',
                    'View': 'View',
                    'Back': 'Back',
                    'Check': 'Check',
                    'Refresh': 'Refresh',
                    'Confirm': 'Confirm',
                    'Confirmation': 'Confirmation',
                    'Accept': 'Accept',
                    'Settings': 'Settings',
                    'Support': 'Support',
                    'FAQ': 'FAQ',
                    'Account': 'Account',
                    'Tariff': 'Tariff',
                    'Select tariff': 'Select tariff',
                    'Statistics': 'Statistics',
                    'Help': 'Help',
                    'Downloads': 'Downloads',
                    'Code': 'Code',
                    'Status': 'Status',
                    'Quick add': 'Quick add',
                    'No Data': 'No Data',
                    'Set user': 'Set user',
                    'Set as owner': 'Set as owner',
                    'Off': 'Off',
                    'Yes': 'Yes',
                    'No': 'No',
                    'Token': 'Token',
                    'Grant': 'Grant',
                    'Reject': 'Reject',
                    'Owner': 'Owner',
                    'Cover': 'Cover',
                    'Audio': 'Audio',
                    'Video': 'Video',
                    'Order': 'Order',
                    'Order again': 'Order again',
                    'Catalog': 'Catalog',
                    'Duration': 'Duration',
                    'Duration, min': 'Duration, min',
                    'Number of series': 'Number of series',
                    'Series': 'Series',
                    'series': 'series',
                    'Set a duration': 'Set a duration',
                    'Set a number of series': 'Set a number of series',
                    'Notifications': 'Notifications',
                    'Notification management': 'Notification management',
                    'To list': 'To list',
                    'Access requests': 'Access requests',
                    'Access request': 'Access request',
                    'Request permission': 'Request permission',
                    'Repeat password': 'Repeat password',
                    'Enter email for verification': 'Enter email for verification',
                    'Enter code for': 'Enter code for',
                    'Send again': 'Send again',
                    'Send code again': 'Send code again',
                    'Send request': 'Send request',
                    'Mediabaza Market': 'Mediabaza Market',
                    'Mediabaza Mdisk': 'Mediabaza Mdisk',
                    'Mediabaza Techno': 'Mediabaza Techno',
                    'showcase and deals': 'showcase and deals',
                    'safe storage and exchange': 'safe storage and exchange',
                    'technology services and integrations': 'technology services and integrations',
                    'Request a demo/consultation': 'Request a demo/consultation',
                    'Connect Mdisk': 'Connect Mdisk',
                    'Select content': 'Select content',
                    'Request integration': 'Request integration',
                    'Offer partnership': 'Offer partnership',
                    'Consent to personal data processing is required to continue': 'Consent to personal data processing is required to continue',
                    'it is a unified digital platform for the media market that combines three key products': 'it is a unified digital platform for the media market that combines three key products',
                    'Register in Mediabaza': 'Register in Mediabaza',
                    'Requests for registration': 'Requests for registration',
                    'confirmPre': 'Confirm pre-registration form for <1>{{email}}</1>',
                    'The code is valid for': 'The code is valid for',
                    'second': 'second',
                    'Re-request code after': 'Re-request code after',
                    'Reset password': 'Reset password',
                    'Change password': 'Change password',
                    'Activate': 'Activate',
                    'Activate account': 'Activate account',
                    // 'Email already registered': 'Email already registered',
                    'Email already registered': 'Congratulations! Your account has been created. A link to set a password has been sent to your email.',
                    'Confirmation code is wrong': 'Confirmation code is wrong',
                    'Old password': 'Old password',
                    'New password': 'New password',
                    'Content unit information': 'Content unit information',
                    'Token is invalid or expired': 'Token is invalid or expired',
                    'Password successfully changed': 'Password successfully changed',
                    'Wait for the letter to the specified email and follow the link': 'Wait for the letter to the specified email and follow the link',
                    "Enter your username and password or apply for registration": "Enter your username and password or apply for registration",
                    'To complete the registration, wait for confirmation from the administrator and follow the link in the letter sent to you': 'To complete the registration, wait for confirmation from the administrator and follow the link in the letter sent to you',
                    'AfterRegister1': 'Thank you for filling out the application to connect to our service.',
                    'AfterRegister2': 'The service is in test mode, so the review period may be up to 2 business days.',
                    'AfterRegister3': 'If it is necessary to clarify the data, we will contact you by phone specified in the application.',
                    'AfterRegister4': 'We will notify you of the outcome of your application by e-mail.',
                    'Contact Support': 'Contact Support',
                    'To continue working, you must confirm ownership of the link': 'To continue working, you must confirm ownership of the link',
                    'A code has been sent to your email, enter it in the field': 'A code has been sent to your email, enter it in the field',
                    "Main": 'Main',
                    'Fill out the pre-registration form for': 'Fill out the pre-registration form for',
                    "Users": "Users",
                    "User": "User",
                    "Firstname": 'Firstname',
                    "Surname": 'Surname',
                    "Company": 'Company',
                    "Phone": 'Phone',
                    "Role": 'Role',
                    "administrators": 'Administrators',
                    "Consumer": 'Consumer',
                    "Consumers": 'Consumers',
                    "Subscribers": 'Subscribers',
                    "Participants": "Participants",
                    "Mediabaza participants": "Mediabaza participants",
                    "consumers": 'Consumer',
                    "Provider": 'Provider',
                    "Providers": 'Providers',
                    "providers": 'Provider',
                    "Moderator": 'Moderator',
                    "Moderators": 'Moderators',
                    "moderators": 'Moderator',
                    "guests": 'Guest',
                    "partners": 'Partner',
                    "OTP": "OTP configured",
                    "moderator": 'Moderator',
                    'Active': 'Active',
                    'Inactive': 'Inactive',
                    'Is active': 'Is active',
                    'Is locked': 'Is locked',
                    'Joined': 'Joined',
                    'Last login': 'Last login',
                    'Profile': 'Profile',
                    'Content': 'Content',
                    'Requests': 'Requests',
                    'Orders': 'Orders',
                    'Login': 'Login',
                    'Login2': 'Login',
                    'See full version': 'See full version',
                    'To view details and place an order, please log in or register': 'To view details and place an order, please log in or register',
                    'Password': 'Password',
                    'Avatar': 'Avatar',
                    'limit': 'limit',
                    'title or title_eng must be specified': 'title or title_eng must be specified',

                    'Registrations': 'Registrations',
                    'Apply for registration': 'Apply for registration',
                    'Trailer': 'Trailer',
                    'Trailer exists': 'Trailer exists',
                    'Type': 'Type',
                    'Collection': 'Collection',
                    'Year': 'Year',
                    'Language': 'Language',
                    'Country': 'Country',
                    'Techinfo': 'Techinfo',
                    'Link': 'Link',
                    'Links': 'Links',
                    'Tags': 'Tags',
                    'List of content': 'List of content',
                    'IMDb': 'IMDb',
                    'Kinopoisk': 'Kinopoisk',
                    '{0} selected': '{0} selected',
                    'Image type not supported': 'Image type not supported',
                    'Content is not available': 'Content is not available',
                    'No rights to view': 'No rights to view',
                    'Showcase': 'Showcase',
                    'Consumers list': 'Consumers list',
                    'Search': 'Search',
                    'Permited': 'Permited',
                    'Not permited': 'Not permited',
                    'Meta': 'Meta',
                    'Show filter': 'Show filter',
                    'Hide filter': 'Hide filter',
                    'Nothing found': 'Nothing found',
                    'Messages': 'Messages',
                    'Message': 'Message',
                    'Download manager': 'Download manager',
                    'Media': 'Media',
                    'Upload': 'Upload',
                    'Create folder': 'Create folder',
                    "block": "Block",
                    "unblock": "Unblock",
                    'ORPHAN_CONTENT': 'To append content, first save the name of the card',
                    'ORPHAN_TRAILER': "To append trailer, first save the name of the card",
                    'ORPHAN_COVER': 'To append cover, first save the name of the card',
                    'Orders filter all': 'All',
                    'Orders filter new': 'New',
                    'Orders filter pending': 'Pending',
                    'Orders filter granted': 'Granted',
                    'Orders filter rejected': 'Rejected',
                    'Orders filter archived': 'Archive',
                    'Orders filter date': 'Order date',
                    'Orders filter date placeholder': 'Choose date',

                    'Orders filter producer': 'Provider',
                    'Orders filter consumer': 'Consumer',

                    'Orders status open': 'New',
                    'Orders status pending': 'Pending',
                    'Orders status granted': 'Granted',
                    'Orders status rejected': 'Rejected',
                    'Orders status canceled': 'Cancelled',

                    'Orders operation open': 'Choose status',
                    'Orders operation pending': 'Pending',
                    'Orders operation grant': 'Grant',
                    'Orders operation reject': 'Reject',
                    'Orders operation download': 'Download',
                    'Orders operation reply': 'Reply',
                    'Orders operation write': 'Write',

                    'Orders xls export': 'Load into xls',

                    'Orders table producer': 'Provider',
                    'Orders table consumer': 'Consumer',
                    'Orders table status': 'Status',
                    'Orders table content': 'Content',
                    'Orders table date': 'Date and time',

                    'FAQ title': 'Frequently Asked Questions (FAQ)',
                    'Feedback your message': 'Your message',
                    'Feedback put message': 'Put your message',
                    'Feedback email': 'Email',
                    'Feedback put email': 'Put your email',
                    'Feedback sent': 'Your message has been sent to the site administrator. Thanks for reaching out!',
                    'Feedback hide': 'Close',

                    'Contacts msk-ix': 'JSC "MSK-IX"',
                    'Contacts msk-ix long': 'Join-stock company "Internet Exchange "MSK-IX"',
                    'Contacts connect': 'Connect and support',
                    'Contacts press': 'PR',
                    'Contacts administration': 'Administration',
                    'Header menu support': 'Support',
                    'SHORT_SECOND': 's',
                    'Date': 'Date',
                    'Time': 'Time',
                    'Start time': 'Start time',
                    'End time': 'End time',
                    'Demo': 'Demo',
                    'You have unsaved changes in content card. Continue?': 'You have unsaved changes in content card. Continue?',
                    'You have unfinished uploads. Continue?': 'You have unfinished uploads. Continue?',
                    'Ordered': 'Ordered',
                    'Rejected': 'Rejected',
                    'Granted': 'Granted',
                    'unknown': 'unknown',
                    'Unknown': 'Unknown',
                    'Enter one-time code': 'Enter one-time code',
                    'Change subscriber status error': 'Change subscriber status error',
                    'Back from view mode': 'Back from view mode',
                    'Meta': 'Meta',
                    'Category': 'Category',
                    'Territory': 'Territory',
                    'Type of rights': 'Type of rights',
                    'Who sees the card': 'Who sees the card',
                    'Accessibility mode': 'Accessibility mode',
                    'Accessibility mode for view': 'Accessibility mode for view',
                    'Accessibility mode for download': 'Accessibility mode for download',
                    'Approve card': 'Approve card',
                    'Change': 'Change',
                    'File deleted': 'File deleted',
                    'File upload': 'File upload',
                    'Card status': 'Card status',
                    'Unit': 'Unit',
                    'Normal': 'Normal',
                    'Draft': 'Draft',
                    'Deleted': 'Deleted',
                    'Censored': 'Censored',
                    'Agreed': 'Agreed',
                    'Legal': 'Legal',
                    'User agreement': 'User agreement',
                    'MSK-IX Personal Data Policy': 'MSK-IX Personal Data Policy',
                    'Personal Data Processing Consent Form': 'Personal Data Processing Consent Form',
                    'Legal Entity': 'Legal Entity',
                    'Firstname is required': 'Firstname is required',
                    'Lastname is required': 'Lastname is required',
                    'Company is required': 'Company is required',
                    'Phone is required': 'Phone is required',
                    'Autofill': 'Autofill',
                    'Exit': 'Exit',
                    'ContactTo': 'Contact',
                    'CONTACT': 'Contact',
                    'PROPOSAL': 'Proposal',
                    'CONCLUDE': 'Conclude',
                    'WAIT': 'Wait',
                    'DISCINSIDE': 'Discuss Inside',
                    'LEntity': 'Legal entity',
                    'Extend all permits': 'Extend all permits',
                    'Contract with': 'Contract with',
                    'Contract between': 'Contract between',
                    'and': 'and',
                    'File information': 'File information',
                    'Delete file': 'Delete file',
                    'Delete cover': 'Delete cover',
                    'Upload file': 'Upload file',
                    'Upload cover': 'Upload cover',
                    'Reply': 'Reply',
                    'Access': 'Access',
                    'Offers': 'Offers',
                    'Name': 'Name',
                    'Contact': 'Contact',
                    'Individual Entrepreneur': 'Individual Entrepreneur',
                    'Self-Employed': 'Self-Employed',
                    'Individual': 'Individual',
                    'Organization': 'Organization',
                    'Organizations': 'Organizations',
                    'Contractor': 'Contractor',
                    'Dictionaries': 'Dictionaries',
                    'Record': 'Record',
                    'Lastname': 'Lastname',
                    'Partner': 'Partner',
                    'Organization name': 'Organization name',
                    'Permission': 'Permission',
                    'Permissions': 'Permissions',
                    'EXTERNAL': 'EXTERNAL',
                    'Created': 'Created',
                    'Updated': 'Updated',
                    'Details': 'Details',
                    'Account name': 'Account name',
                    'About': 'About',
                    'About service': 'About service',
                    'About content': 'About content',
                    'group': 'group',
                    'Group': 'Group',
                    'Groups': 'Groups',
                    'Taxnum': 'Taxnum',
                    'Contract with Mediabaza': 'Contract with Mediabaza',
                    'Total bitrate': 'Total bitrate',
                    'Bitrate': 'Bitrate',
                    'Port': 'Port',
                    'port': 'port',
                    'Backup source': 'Backup source',
                    'Monitoring': 'Monitoring',
                    'Monitoring data': 'Monitoring data',
                    'My consumers': 'My consumers',
                    'My TV': 'My TV channels',
                    'My access': 'My access',
                    'Choose a organization': 'Choose a organization',
                    'Promotion': 'Special offer',
                    'Promotions': 'Special offers',
                    'Recipient': 'Recipient',
                    "To contract": "To contract",
                    'ISSUED': 'Issued',
                    'Issue permission': 'Issue permission',
                    'Permission to create keys has been sent': 'Permission to create keys has been sent',
                    'The permission has already been sent': 'The permission has already been sent',
                    'WORKING': 'Working',
                    'REVOKED': 'Revoked',
                    'EXPIRED': 'Expired',
                    'EXPIRES': 'Expires',
                    'Validity period not specified': 'Validity period not specified',
                    'Severity': 'Severity',
                    'Orientation': 'Orientation',
                    'Forwarded': 'Forwarded',
                    'Delete organization error': 'Delete organization error',
                    'Access denied': 'Access denied',
                    'Site owner': 'Site owner',
                    'Владельцы сайта': 'Site owner',
                    'Поставщик': 'Provider',
                    'Потребитель': 'Consumer',
                    'Партнер': 'Partner',
                    'Partner': 'Partner',
                    'Партнер модератор': 'Partner moderator',
                    'Partner moderator': 'Partner moderator',
                    'Partner source Medialogistika': 'Partner source Medialogistika',
                    'Партнер источник Медиалогистика': 'Partner source Medialogistika',
                    'Partner source': 'Partner source',
                    'Guest': 'Guest',
                    'No guest': 'No guest',
                    'Lounge': 'Lounge',
                    'Users without accounts': 'Users without accounts',
                    'Users not logined': 'Not logined users',
                    'Account owners not logined': 'Account owners not logined',
                    'Accounts without agreement': 'Accounts without agreement',
                    'Organizations without taxnum': 'Organizations without taxnum',
                    'The service is not available in the selected tariff.': 'The service is not available in the selected tariff.',
                    'SeeTariffs': 'See <1>tariffs</1>',
                    'SubsToTelegram': 'Subscribe to <1>Telegram</1> notifications',
                    'Notification date': 'Notification date',
                    'Notification type': 'Notification type',
                    'Urgent': 'Urgent',
                    'High': 'High',
                    'Low': 'Low',
                    'Notify date placeholder': 'Choose date',
                    'Specified in the request': 'Specified in the request',
                    'day': 'day',
                    'days': 'days',
                    'days2': 'days',
                    'Absent': 'Absent',
                    'Problem': 'Problem',
                    'Warning': 'Warning',
                    'Secret': 'Secret',
                    'configured': 'configured',
                    'not configured': 'not configured',
                    'Without license': 'Without license',
                    'File information': 'Информация о файле',
                    'Delete file': 'Delete file',
                    'Frame resolution': 'Frame resolution',
                    'Audio codec': 'Audio codec',
                    'Video codec': 'Video codec',
                    'Entire report': 'Quality report',
                    'Show CRC': 'Checksums',
                    'Show more': 'Show more',
                    'By e-mail': 'By e-mail',
                    'In Telegram': 'In Telegram',
                    'Import from file': 'Import from file',
                    'Estimated price': 'Estimated price',
                    'Price': 'Price',
                    'Price negotiable': 'Price negotiable',
                    'Organization accounts': 'Organization accounts',
                    'Enter 2fa code': 'Enter 2fa code',
                    'promotion': 'promotion',
                    'event': 'promotion',
                    'advertising': 'promotion',
                    'other': 'promotion',
                    'landing': 'landing',
                    'New ones first': 'New ones first',
                    'Nearest first': 'Nearest first',
                    'Subscribe to newsletter': 'Receive information and marketing communications',
                    'The page version is out of date and needs to be reloaded': 'The page version is out of date and needs to be reloaded',
                    'Please confirm that you are over 18': 'Please confirm that you are over 18',
                    'Are you sure you want to delete this file?': 'Are you sure you want to delete this file?',
                    'Are you sure you want to delete this trailer?': 'Are you sure you want to delete this trailer?',
                    'Are you sure you want to delete this cover?': 'Are you sure you want to delete this cover?',
                    'Are you sure you want to delete this document?': 'Are you sure you want to delete this document?',
                    'Are you sure you want to delete this request?': 'Are you sure you want to delete this request?',
                    'Are you sure you want to delete this organization?': 'Are you sure you want to delete this organization?',
                    'Are you sure you want to unlock this content unit?': 'Are you sure you want to unlock this content unit?',
                    'Are you sure you want to lock this content unit?': 'Are you sure you want to lock this content unit?',
                    'Are you sure you want to delete this content unit?': 'Are you sure you want to delete this content unit?',
                    'Are you sure you want to delete this service unit?': 'Are you sure you want to delete this service unit?',
                    'This link is invalid': 'This link is invalid',
                    'Log out': 'Log out',
                    'All registered': 'All registered',
                    'Not available': 'Not available',
                    'Select the quality and version of the TV signal': 'Select the quality and version of the TV signal',
                    'Show to unregistered users': 'Show to unregistered users',
                    'Show on index page': 'Show on index page',
                    'Show on recommended': 'Show on recommended',
                    'Two-factor authentication must be enabled to download': 'Two-factor authentication must be enabled to download',
                    'To use Disk, two-factor authentication must be enabled': 'To use Disk, two-factor authentication must be enabled',
                    'The comment will be visible only to you': 'The comment will be visible only to you',
                    'ServiceAggreementMsg': 'Please confirm your agreement with <1>user agreement</1> to continue working with the Mediabase resources.',
                    'PDConsent': 'Please confirm <1>consent to the processing of personal data</1> for further work with the Mediabase resources.',
                    'MMFeedback': 'If you did not find the name of the TV channel, <br /> contact <1>support</1> to add.',
                    '2FAConfigureLink': 'To set up, follow the <1>link</1>',
                    'Consent to the processing of personal data': 'Consent to the processing of personal data',
                    'Agreement with the user agreement': 'Agreement with the user agreement',
                    '429_message': 'The server received too many requests in a short period of time and temporarily restricted access to protect against overload',
                    'Try back later': 'Try back later',
                    'submit_a_request': 'Submit a request',
                    'participate': 'Participate',
                    'register': 'Register',
                    'get_an_offer': 'Get an offer',
                    'find_out_more': 'Find out more',
                    'go_to': 'Go to',
                    'see': 'See',
                    'order': 'Order',
                    'connect': 'Connect',
                    'contact': 'Contact',
                    'get_a_consultation': 'Get a consultition',
                    'if exists': 'if exists',
                    'Full name': 'Full name',
                    'Action type': 'Action type',
                    ...mdx.en,
                }
            },
            ru: {
                account: account.ru,
                cms: cms.ru,
                content: content.ru,
                component: component.ru,
                dashboard: dashboard.ru,
                profile: profile.ru,
                modal: modal.ru,
                tv: tv.ru,
                group: group.ru,
                order: order.ru,
                storage: storage.ru,
                translations: {
                    "TGBOT": "Телеграм-бот",
                    "Show access keys": "Показать ключи доступа",
                    "Access keys": "Ключи доступа",
                    "Access key": "Ключ доступа",
                    "Key": "Ключ",
                    "Object": "Объект",
                    "SAVE_KEYS": "Сохраните пару ключей для доступа из внешних систем перед тем как закрыть это окно",
                    "KEYS_INFO": "Здесь будет инструкция по применению",
                    "Occupied": "Занято",
                    "Size": "Размер",
                    "Sorting": "Сортировка",
                    "People": "Люди",
                    "Copy": "Скопировать",
                    "Copied": "Скопировано",
                    "Done": "Готово",
                    "In progress": "В процессе",
                    "In line": "В очереди",
                    "Disk": "Мдиск",
                    'Value': 'Значение',
                    "Action": "Действие",
                    "Filename": "Название",
                    "Compressed": "Сжатый размер",
                    "Details": "Подробнее",
                    "Today": "Сегодня",
                    "Yesterday": "Вчера",
                    "Birthday": "День рожденья",
                    "Pin": "Закрепить",
                    "Unpin": "Открепить",
                    "On": "Включено",
                    "OFF": "Выключено",
                    "Close": "Закрыть",
                    "Clean": "Очистить",
                    "Apply": "Применить",
                    "Filter": "Фильтр",
                    "Filters": "Фильтры",
                    "Deals": "Сделки",
                    "Registry": "Реестр",
                    "Portfolio": "Портфолио",
                    "Partners": "Партнёры",
                    "History": "История",
                    "Contract": "Договор",
                    "Contracts": "Договоры",
                    "Contract number": "Номер договора",
                    "Contract term": "Срок договора",
                    "Reliable partner": "Надёжный партнёр",
                    "New document": "Новый документ",
                    "Edit document": "Редактирование документа",
                    "Load document": "Загрузите документ",
                    "New contract": "Новый договор",
                    "Document": "Документ",
                    "Document number": "№ документа",
                    "Document term": "Срок документа",
                    "Linked documents": "Связанные документы",
                    "Initiator": "Инициатор",
                    "See all": "Смотреть все",
                    "Other events": "Другие мероприятия",
                    "Other promotions": "Другие акции",
                    "All news": "Все новости",
                    "All polls": "Проголосовать",
                    "All adverts": "Все объявления",
                    "until": "до",
                    "Take part": "Участвовать",
                    "We recommend": "Рекомендуем",
                    "Term": "Срок",
                    "Archive": "Архив",
                    "Number": "Номер",
                    "Service type": "Тип услуги",
                    "Product type": "Тип продукта",
                    "Product": "Продукт",
                    "Products": "Продукты",
                    "Matrix": "Матрица",
                    "Parameters": "Параметры",
                    "TV signal": "Телесигнал",
                    "Redact": "Редактировать",
                    "Age": "Возраст",
                    "Agerestriction": "Возрастное ограничение",
                    "provider_owner": "Поставщик владелец",
                    "consumer_auditor": "Потребитель аудитор",
                    "Enter to account": "Войти в аккаунт",
                    'Accounts': 'Аккаунты',
                    'My accounts': 'Мои аккаунты',
                    'Ask our support': 'Задайте вопрос нашей поддержке',
                    'Agreement': 'Соглашение',
                    'Mediabaza': 'Медиабаза',
                    'MM': 'Справочник телеканалов',
                    'Scope of rights': 'Объём прав',
                    'Broadcasting area': 'Территория вещания',
                    'Environment': 'Среда',
                    'Russia': 'Россия',
                    'Worldwide': 'Весь мир',
                    'Cable broadcasting': 'Кабельное вещание',
                    'Distribution environment': 'Среда распространения',
                    'Comment': 'Комментарий',
                    'comment': 'комментарий',
                    'Next': 'Дальше',
                    'Cancel': 'Отменить',
                    'Transcode': 'Транскодировать',
                    'Transcoded': 'Транскодировано',
                    'Transcoding': 'Транскодирование',
                    'Download transcoded': 'Скачать транскодированное',
                    'Download all': 'Скачать все',
                    'email': 'электронная почта',
                    'Email': 'Электронная почта',
                    'Enter Email': 'Введите эл. почту',
                    'Enter password': 'Введите пароль',
                    'Passwords do NOT match': 'Пароли не совпадают',
                    'a marketplace for video content, TV channels, and media services': 'маркетплейс видеоконтента, телеканалов и медиасервисов',
                    'Everything you need for content operations—all in one digital hub: from search and acquisition to delivery, rights management, and legal compliance.': 'Всё, что нужно для работы с контентом — в одном цифровом окне: от поиска и закупки до доставки, оформления прав и соблюдения законодательства.',
                    'Marketplace <br>to buy and sell media content': 'Mаркетплейс для<br/> продавцов и&nbsp;покупателей медиаконтента',
                    'Unique content': 'Уникальный контент',
                    'Piracy Protection': 'Защита от&nbsp;пиратства',
                    'Free access to basic functions': 'Бесплатный доступ к&nbsp;основным функциям',
                    'Affordable price': 'Доступные цены',
                    'User friendly support': 'Дружественная клиентская поддержка',
                    'Content Search': 'Поиск контента',
                    'Unique catalog of downloadable content and TV channels for easy search and order': 'Уникальный каталог загружаемого контента для удобного поиска и заказа',
                    'Licensing Rights': 'Передача прав',
                    'Safe transactions between a licensor and a licensee. Highly automated processes': 'Безопасные сделки между лицензиатами и лицензиарами. Высокая автоматизация процедур',
                    'Delivery': 'Доставка',
                    'Reliable content delivery of heavy-loaded video content in innovative formats VR, 4К, 8К, HDR': 'Надежная доставка тяжело-загружаемого видеоконтента в инновационных форматах VR, 4К, 8К, HDR',
                    'Updating': 'Обновление',
                    '<br />catalog of streaming services': 'каталогов интернет-кинотеатров',
                    'Distributing': 'Распространение',
                    '<br />ad-videos to the regional network': 'рекламных роликов по&nbsp;региональной сети',
                    'Uploading': 'Загрузка',
                    'Card files': 'Файлы карточки',
                    'Show on Disk': 'Показать на Мдиске',
                    'movies to multiplex movie theaters': 'фильмов в&nbsp;многозальные кинотеатры',
                    'Setting content': 'Программное наполнение',
                    'for TV channels': 'телеканалов',
                    'Increase the efficiency of your business with the help of Mediabase if your business is': 'Повысьте эффективность своего бизнеса с помощью Медиабазы, если ваш бизнес это',
                    'Cloud platform to increase the efficiency of interactions between professional participants in the media market': 'Облачная платформа для повышения эффективности взаимодействия профессиональных участников медиарынка',
                    'For Sellers': 'Для продавцов',
                    'Sell Сontent': 'Продать контент',
                    'Become a seller': 'Стать продавцом',
                    'Single entry point to reach your customers': 'Единая точка входа к своим покупателям',
                    'Safe storage of content archive': 'Безопасное хранение архива контента',
                    'Fast delivery of heavy 4K content': 'Быстрая доставка тяжелого 4К контента',
                    'Content distribution control': 'Контроль распространения контента',
                    'Lead generation': 'Генерация лидов',
                    'For Buyers': 'Для покупателей',
                    'Buy Сontent': 'Купить контент',
                    'Become a buyer': 'Стать покупателем',
                    'Easy to use catalog to search for content from all over the world': 'Удобный каталог для поиска нового контента со всего мира',
                    'Easy content ordering': 'Простая процедура заказа контента',
                    'Video transcoding into any format': 'Преобразование видео в необходимые форматы',
                    'Downloading using speed protocol': 'Загрузка с использованием скоростного протокола',
                    'Metadata is included': 'Сопровождение контента пакетом метаинформации',
                    'Get free access to try out the platform': 'Получите бесплатный доступ, чтобы испытать сервис',
                    'What Mediabaza Offers': 'Что даёт «Медиабаза»',
                    'Exclusive Deals & Promotions': 'Уникальные предложения и акции',
                    'Solutions for TV Channels': 'Работаете с телеканалами?',
                    'Additional services of Mediabase': 'Дополнительные услуги Медиабазы',
                    'Subtitling, AI-powered translation, video content verification for compliance with legislation': 'Создание субтитров, перевод на базе ИИ, проверка видеоконента на соответствие законодательству',
                    'Get Started Today': 'Начните сегодня',
                    'Sign up at': 'Зарегистрируйтесь на <1>mediabaza.ru</1> — получите доступ к контенту, инструментам и условиям, которые работают на ваш результат.',
                    'Powered by MSK-IX — a leading internet infrastructure provider with 30 years of industry trust and expertise.': 'Проект создан MSK-IX — ведущим интернет-инфраструктурным оператором с 30-летней историей и доверием отрасли.',
                    'Get Access': 'Запросить доступ',
                    'Feedback': 'Обратная связь',
                    'Contacts': 'Контакты',
                    'To showcase': 'К витрине',
                    'To tv': 'К карточке телеканала',
                    'TV': 'Телеканал',
                    'To adverts list': 'К списку объявлений',
                    'To news list': 'К списку новостей',
                    'To promo list': 'К списку акций',
                    'To polls list': 'К списку голосований',
                    'To many requests': 'Слишком много запросов',
                    'Re-vote': 'Переголосовать',
                    'Color': 'Цвет',
                    'News': 'Новости',
                    'No news': 'Новостей нет',
                    'Download': 'Скачать',
                    'Downloading': 'Скачивание',
                    'Download metadata': 'Скачать метаданные',
                    'Metadata': 'Метаданные',
                    'Download again': 'Скачать повторно',
                    'Create': 'Создать',
                    'Send': 'Отправить',
                    'Content unit': 'Контент',
                    'TV (content)': 'Телеканал (контент)',
                    'TV channel': 'ТВ',
                    'TV channels': 'Телеканалы',
                    'Video content': 'Видеоконтент',
                    'Common content': 'Обычный контент',
                    'Vertical content': 'Вертикальный контент',
                    'Films': 'Фильмы',
                    'Ad': 'Реклама',
                    'Finished': 'Завершено',
                    'The event has ended': 'Событие завершено',
                    'Vote': 'Голос',
                    'Votes': 'Голосов',
                    'votes': 'голосов',
                    'Series2': 'Сериалы',
                    'Create a new card': 'Создать новую карточку',
                    'Create a content unit': 'Создание единицы контента',
                    'Create a tv unit': 'Создание карточки телеканала',
                    'Create a service unit': 'Создание карточки услуги',
                    '+ Upload files': '+ Загрузить файлы',
                    'Enter a title': 'Укажите название',
                    'Enter a s3 path': 'Выберите или создайте папку на Мдиске для связи с карточкой',
                    'S3 path': 'Папка карточки на Мдиске',
                    'S3 name': 'Имя в S3 клиенте',
                    'Revert': 'Вернуть',
                    'TV channel name': 'Название телеканала',
                    'Enter a name': 'Укажите имя',
                    'Enter a price': 'Укажите стоимость',
                    'Enter license number': 'Укажите номер лицензии',
                    'Title': 'Название',
                    'optional': 'необязательно',
                    'required': 'обязательно',
                    'Load cover': 'Загрузите обложку',
                    'Load logo or cover': 'Загрузите логотип или обложку',
                    'Load demo': 'Загрузите демо',
                    'Choose': 'Выбрать',
                    'Choose a sources': 'Выберите источники',
                    'Choose a tvchannel': 'Выберите телеканал',
                    'Choose a agerestriction': 'Выберите возрастное ограничение',
                    'Choose a task': 'Выберите задачу',
                    'Choose a category': 'Выберите категорию',
                    'Fill in the information': 'Заполните информацию',
                    'Choose a country': 'Выберите страну',
                    'Choose a language': 'Выберите язык',
                    'Choose a genre': 'Выберите жанр',
                    'Choose a collection': 'Выберите коллекцию',
                    'Choose a provider': 'Выберите правообладетеля',
                    'Country of Origin': 'Страна производства',
                    'Voice language': 'Язык озвучения',
                    'Production': 'Производство',
                    'Broadcast': 'Трансляция',
                    'Broadcasting': 'Вещание',
                    'Watch TV channel broadcast': 'Смотреть эфир телеканала',
                    'Demo video': 'Демо-ролик',
                    'Genre': 'Жанр',
                    'Subtitle': 'Субтитры',
                    'Choose a year': 'Выберите год',
                    'Year of issue': 'Год выпуска',
                    'Description': 'Описание',
                    'Enter a description': 'Введите описание',
                    'Quality': 'Качество',
                    'Choose a quality': 'Выберите качество',
                    'Choose an accessibility mode': 'Выберите режим доступности',
                    'To view': 'Для просмотра',
                    'To download': 'Для скачивания',
                    'Choose a role': 'Выберите роль',
                    'Choose a specialization': 'Выберите специализацию',
                    'Choose a customers': 'Выберите потребителей',
                    'Choose a customers to view': 'Выберите потребителей для просмотра',
                    'Choose a customers to download': 'Выберите потребителей для скачивания',
                    'Offer consumers': 'Предложите потребителям',
                    'All': 'Все',
                    'List': 'Список',
                    'Nobody': 'Никто',
                    'from': 'из',
                    'Subject': 'Тематика',
                    'Availability': 'Доступность',
                    'Count of orders': 'Количество заявок',
                    'Count of downloads': 'Количество скачиваний',
                    'Fill in': 'Заполнить',
                    'Filling': 'Заполнение',
                    'Filled out': 'Заполняется',
                    'Checked': 'Проверено',
                    'In favorites': 'В избранном',
                    'New': 'Новинка',
                    'Blocked by moderator': 'Заблокировано медератором',
                    'Access Denied.': 'Доступ запрещен',
                    'Available to group': 'Доступно группе',
                    'Available to everyone': 'Доступно всем',
                    'Available to VIP': 'Доступно VIP',
                    'Lock': 'Блокировка',
                    'By date': 'По дате загрузки',
                    'By name': 'По названию',
                    'By checked': 'Сначала проверенные',
                    'for': 'для',
                    'For all': 'Для всех',
                    'For VIP': 'Для VIP',
                    'For group': 'Выборочно',
                    'For no one': 'Ни для кого',
                    'Category of rights': 'Категория прав',
                    'Search': 'Поиск',
                    'Search by partners': 'Поиск по партнёрам',
                    'Search by registry': 'Поиск по реестру',
                    'Search by name': 'Поиск по названию',
                    'Search by name and supplier': 'Поиск по названию и поставщику',
                    'Search by guests': 'Поиск по гостям',
                    'Search by accounts': 'Поиск по аккаунтам',
                    'Search by catalog': 'Поиск по каталогу',
                    'Search by requests and content': 'Поиск по заявкам и контенту',
                    'Search by object': 'Поиск по объекту',
                    'Search by promo': 'Поиск по акциям',
                    'Promocode': 'Промокод',
                    'You do not have a valid account': 'У Вас нет действующего аккаунта',
                    'Can download': 'Можно скачать',
                    'Can view': 'Просмотр',
                    'Can downloads': 'Скачивание',
                    'Source': 'Источник',
                    'Sources': 'Источники',
                    'Order several': 'Заказать несколько',
                    'Option': 'Опция',
                    'Options': 'Опции',
                    'Deffered': 'Отложенный',
                    'Count': 'Количество',
                    'Custom date range': 'Свой диапазон дат',
                    'since': 'с',
                    'Since': 'С',
                    'till': 'по',
                    'Till': 'По',
                    'Drag file here': 'Перетащите сюда файл',
                    'Drag files here': 'Перетащите сюда файлы',
                    'or select on computer': 'или выберите на компьютере',
                    'Supported file formats': 'Поддерживаемые форматы',
                    'Supported file formats mp4, webm и ogg': 'Поддерживаемые форматы mp4, webm и ogg',
                    'Page not found': 'Страница не найдена',
                    'You can go ': 'Вы можете вернуться ',
                    'back': 'назад',
                    ' or go to the ': ' или перейти в ',
                    'showcase': 'каталог',
                    'Sign': 'Вход',
                    'Log In': 'Вход',
                    'Sign in': 'Войти',
                    'Sign Up': 'Регистрация',
                    'Forgot password': 'Забыли пароль',
                    'Recover password': 'Восстановить пароль',
                    'Forgot your password': 'Забыли пароль',
                    'Register': 'Зарегистрироваться',
                    'The action is available for registered users': 'Действие доступно для зарегистрированных пользователей',
                    'Voting is available only to registered users': 'Голосование доступно только зарегистрировнным пользователям',
                    'Tools': 'Инструменты',
                    'Instructions': 'Инструкция',
                    'Load into xls': 'Выгрузить в xls',
                    'Load into csv': 'Выгрузить в csv',
                    'Save as': 'Сохранить как',
                    'Avatar': 'Аватар',
                    'limit': 'максимум',
                    'title or title_eng must be specified': 'Название не должно быть пустым',
                    'Enter a techinfo': 'Введите параметры',
                    'Title is required': 'Укажите название',
                    'Image is required': 'Изображение обязательно',
                    'This field is required': 'Это обязательное поле',
                    'Message is required': 'Введите сообщение',
                    'Email is required': 'Укажите эл. почту',
                    'Code is required': 'Укажите код из письма',
                    'Invalid code': 'Код должен состоять из 6 цифр',
                    'Download the file in pdf format': 'Загрузите файл в формате pdf',
                    'File': 'Файл',
                    'Folder': 'Папка',
                    'files': 'файлов',
                    'Files': 'Файлы',
                    'used': 'использовано',
                    'Load error': 'Ошибка загрузки',
                    'Delete request error': 'Ошибка удаления заявки',
                    'Change permissions error': 'Ошибка изменения прав',
                    'Save failed': 'Ошибка сохранения',
                    'Delete failed': 'Ошибка удаления',

                    'This password is too short. It must contain at least 8 characters.': 'Введённый пароль слишком короткий. Он должен содержать как минимум 8 символов.',
                    'This password is too common.': 'Введённый пароль слишком широко распространён.',
                    'This password is entirely numeric.': 'Введённый пароль состоит только из цифр.',
                    'Your password can’t be too similar to your other personal information.': 'Пароль не должен быть слишком похож на другую вашу личную информацию.',
                    'Your password can’t be a commonly used password.': 'Пароль не должен быть слишком простым и распространенным.',
                    'Your password can’t be entirely numeric.': 'Пароль не может состоять только из цифр.',

                    'Delivered': 'Доставлено',
                    'Handled': 'Обработано',
                    'ALL': 'Всего',
                    'MY': 'Мои',
                    'CUSTOM': 'Список',
                    'NOTHING': 'Никому',
                    'Notification list': 'Уведомления',
                    'View Permissions': 'Права просмотра',
                    'Download Permissions': 'Права скачивания',
                    'Novelty': 'Новинки',
                    'Admin dashboard': 'Панель администратора',
                    'Consumer dashboard': 'Панель потребителя',
                    'Provider dashboard': 'Панель поставщика',
                    'Guest dashboard': 'Гостиная',
                    'Add': 'Добавить',
                    'Edit': 'Изменить',
                    'Delete': 'Удалить',
                    'Deleted': 'Удалено',
                    'Success': 'Успешно',
                    'Error': 'Ошибка',
                    'View': 'Смотреть',
                    'Save': 'Сохранить',
                    'Edit': 'Редактирование',
                    'Back': 'Назад',
                    'Check': 'Проверить',
                    'Code': 'Код',
                    'Status': 'Статус',
                    'Refresh': 'Обновить',
                    'Confirm': 'Подтвердить',
                    'Confirmation': 'Подтверждение',
                    'Accept': 'Принять',
                    'Settings': 'Настройки',
                    'Support': 'Поддержка',
                    'FAQ': 'ЧаВо',
                    'Account': 'Аккаунт',
                    'Tariff': 'Тариф',
                    'Select tariff': 'Выбрать тариф',
                    'Statistics': 'Статистика',
                    'Downloads': 'Скачивания',
                    'Help': 'Помощь',
                    'Quick add': 'Добавить быстро',
                    'No Data': 'Нет данных',
                    'Off': 'Отключить',
                    'Set user': 'Стать пользователем',
                    'Set as owner': 'Войти как владелец',
                    'Yes': 'Да',
                    'No': 'Нет',
                    'Token': 'Токен',
                    'Grant': 'Разрешить',
                    'Reject': 'Отказать',
                    'Owner': 'Владелец',
                    'Cover': 'Обложка',
                    'Audio': 'Аудио',
                    'Video': 'Видео',
                    'Order': 'Заказать',
                    'Order again': 'Заказать повторно',
                    'Catalog': 'Каталог',
                    'Duration': 'Длительность',
                    'Duration, min': 'Длительность, минут',
                    'Number of series': 'Количество серий',
                    'Series': 'Серий',
                    'series': 'серий',
                    'Set a duration': 'Укажите длительность в минутах',
                    'Set a number of series': 'Укажите количество серий',
                    'Notifications': 'Уведомления',
                    'Notification management': 'Управление уведомлениями',
                    'To list': 'К списку',
                    'Access requests': 'Заявки на доступ',
                    'Access request': 'Заявка на доступ',
                    'Request permission': 'Запросить разрешение',
                    'Repeat password': 'Повтор пароля',
                    'Enter email for verification': 'Введите email для проверки',
                    'Enter code for': 'Введите код для',
                    'You can re-request in': 'Перезапросить можно через',
                    'Send again': 'Отправить еще раз',
                    'Send code again': 'Отправить код еще раз',
                    'Send request': 'Отправить запрос',
                    'Mediabaza Market': 'Медиабаза Маркет',
                    'Mediabaza Mdisk': 'Медиабаза Мдиск',
                    'Mediabaza Techno': 'Медиабаза Техно',
                    'showcase and deals': 'витрина и сделки',
                    'safe storage and exchange': 'безопасное хранение и обмен',
                    'technology services and integrations': 'технологические сервисы и интеграции',
                    'Request a demo/consultation': 'Запросить демо/консультацию',
                    'Connect Mdisk': 'Подключить Мдиск',
                    'Select content': 'Подобрать контент',
                    'Request integration': 'Запросить интеграцию',
                    'Offer partnership': 'Предложить партнерство',
                    'Consent to personal data processing is required to continue': 'Для продолжения необходимо согласие на обработку персональных данных',
                    'it is a unified digital platform for the media market that combines three key products': 'это единая цифровая платформа для медиарынка, которая объединяет три ключевых продукта',
                    'Register in Mediabaza': 'Зарегистрироваться в Медиабазе',
                    'Requests for registration': 'Заявки на регистрацию',
                    'confirmPre': 'Подтвердите форму предварительной регистрации для <1>{{email}}</1>',
                    'The code is valid for': 'Код действителен еще',
                    'second': 'секунда',
                    'seconds': 'секунд',
                    'Re-request code after': 'Перезапросить код через',
                    'Reset password': 'Запрос на сброс пароля',
                    'Change password': 'Изменить пароль',
                    'Activate': 'Активировать',
                    'Activate account': 'Активация аккаунта',
                    // 'Email already registered': 'Email уже зарегистрирован',
                    'Email already registered': 'Поздравляем! Ваша учетная запись создана. Вам на почту направлена ссылка для установки пароля.',
                    'Confirmation code is wrong': 'Неверный код подтверждения',
                    'Old password': 'Старый пароль',
                    'New password': 'Новый пароль',
                    'Content unit information': 'Информация о единице контента',
                    'Token is invalid or expired': 'Токен неверен либо просрочен',
                    'Password successfully changed': 'Пароль успешно изменен',
                    'Wait for the letter to the specified email and follow the link': 'Дождитесь письма на узазанный email и перейдите по ссылке',
                    "Enter your username and password or apply for registration": "Введите логин и пароль или подайте заявку на регистрацию",
                    'To complete the registration, wait for confirmation from the administrator and follow the link in the letter sent to you': 'Для окончания регистрации дождитесь подтверждения от администратора и перейдите по сслылке в отправленном вам письме',
                    'AfterRegister1': 'Спасибо за заполнение заявки  на подключение к нашему сервису.',
                    'AfterRegister2': 'Сервис работает в тестовом режиме, поэтому срок рассмотрения может составить до 2 рабочих дней.',
                    'AfterRegister3': 'При необходимости уточнить данные мы свяжемся с Вами по телефону, указанному в заявке.',
                    'AfterRegister4': 'О результатах рассмотрения заявки мы сообщим по электронной почте.',
                    'Contact Support': 'Обратиться в поддержку',
                    'To continue working, you must confirm ownership of the link': 'Для дальнейшей работы необходимо подтвердить владение ссылкой',
                    'A code has been sent to your email, enter it in the field': 'Вам на почту был отправлен код, введите его в поле',
                    "Main": 'На главную',
                    'Fill out the pre-registration form for': 'Заполните форму предварительной регистрации для',
                    "Users": 'Пользователи',
                    "User": 'Пользователь',
                    "Firstname": 'Имя',
                    "Surname": 'Отчество',
                    "Company": 'Компания',
                    "Phone": 'Телефон',
                    "Role": 'Роль',
                    "administrators": 'Администратор',
                    "administrator": 'Администратор',
                    "consumer": 'Потребитель',
                    "Consumer": 'Потребитель',
                    "Consumers": 'Потребители',
                    "Subscribers": 'Потребители',
                    "Participants": "Участники",
                    "Mediabaza participants": "Участники Медиабазы",
                    "consumers": 'Потребитель',
                    "provider": 'Поставщик',
                    "Providers": 'Поставщики',
                    "Provider": 'Поставщик',
                    "providers": 'Поставщик',
                    "Moderator": 'Модератор',
                    "Moderators": 'Модераторы',
                    "moderators": 'Модератор',
                    "guests": 'Гость',
                    "partners": 'Партнер',
                    "OTP": "Одноразовый пароль настроен",
                    "moderator": 'Модератор',
                    'Active': 'Активные',
                    'Inactive': 'Неактивные',
                    'Is active': 'Активен',
                    'Is locked': 'Заблокирован',
                    'Joined': 'Дата регистрации',
                    'Last login': 'Последний вход',
                    'Profile': 'Профиль',
                    'Content': 'Контент',
                    'Requests': 'Заявки',
                    'Orders': 'Заявки',
                    'Login': 'Логин',
                    'Login2': 'Авторизоваться',
                    'See full version': 'Посмотреть полную версию',
                    'To view details and place an order, please log in or register': 'Чтобы посмотреть детали и сделать заказ войдите или зарегистрируйтесь',
                    'Password': 'Пароль',
                    'Registrations': 'Регистрации',
                    'Apply for registration': 'Подать заявку на регистрацию',
                    'Trailer': 'Трейлер',
                    'Trailer exists': 'Трейлер загружен',
                    'Type': 'Тип',
                    'Collection': 'Коллекция',
                    'Year': 'Год',
                    'Language': 'Язык',
                    'Country': 'Страна',
                    'Techinfo': 'Тех. инфо',
                    'Link': 'Ссылка',
                    'Links': 'Связи',
                    'Tags': 'Теги',
                    'List of content': 'Список контента',
                    'IMDb': 'IMDb',
                    'Kinopoisk': 'Кинопоиск',
                    '{0} selected': '{0} выбрано',
                    'Image type not supported': 'Тип изображения не поддерживается',
                    'Content is not available': 'Контент недоступен',
                    'No rights to view': 'Отсутствуют права на просмотр',
                    'Showcase': 'Витрина',
                    'Consumers list': 'Список потребителей',
                    'Search': 'Искать',
                    'Permited': 'Успешно',
                    'Not permited': 'Запрещено',
                    'Meta': 'Мета',
                    'Show filter': 'Показать фильтр',
                    'Hide filter': 'Спрятать фильтр',
                    'Nothing found': 'Ничего не найдено',
                    'Messages': 'Сообщения',
                    'Message': 'Сообщение',
                    'Download manager': 'Менеджер загрузок',
                    'Media': 'Медиа',
                    'Upload': 'Загрузить',
                    'Create folder': 'Создать папку',
                    "block": "Заблокировать",
                    "unblock": "Разблокировать",
                    'ORPHAN_CONTENT': 'Для добавления контента, сначала сохраните название карточки',
                    'ORPHAN_TRAILER': "Для добавления демо ролика, сначала сохраните название карточки",
                    'ORPHAN_COVER': 'Для добавления обложки, сначала сохраните название карточки',
                    'Orders filter all': 'Все',
                    'Orders filter new': 'Новые',
                    'Orders filter pending': 'На рассмотрении',
                    'Orders filter granted': 'Доступ разрешён',
                    'Orders filter rejected': 'Не договорились',
                    'Orders filter archived': 'Архив',
                    'Orders filter date': 'Дата заявки',
                    'Orders filter date placeholder': 'Выберите дату',

                    'Orders filter producer': 'Поставщик',
                    'Orders filter consumer': 'Потребитель',

                    'Orders status open': 'Новая',
                    'Orders status pending': 'На рассмотрении',
                    'Orders status granted': 'Успешно',
                    'Orders status rejected': 'Не договорились',
                    'Orders status canceled': 'Отменена',

                    'Orders operation open': 'Выберите статус',
                    'Orders operation pending': 'На рассмотрении',
                    'Orders operation grant': 'Разрешить',
                    'Orders operation reject': 'Отказано',
                    'Orders operation download': 'Скачать',
                    'Orders operation reply': 'Ответить',
                    'Orders operation write': 'Написать',

                    'Orders xls export': 'Выгрузить в xls',

                    'Orders table producer': 'Поставщик',
                    'Orders table consumer': 'Потребитель',
                    'Orders table status': 'Статус',
                    'Orders table content': 'Контент',
                    'Orders table date': 'Дата и время',

                    'FAQ title': 'Часто задаваемые вопросы (FAQ)',
                    'Feedback your message': 'Ваше сообщение',
                    'Feedback put message': 'Оставьте сообщение',
                    'Feedback email': 'Эл. почта',
                    'Feedback put email': 'Укажите эл. почту',
                    'Feedback sent': 'Ваше сообщение отправлено администратору сайта. Спасибо за обращение!',
                    'Feedback hide': 'Хорошо',

                    'Contacts msk-ix': 'АО «ЦВКС «МСК-IX»',
                    'Contacts msk-ix long': 'Акционерное общество «Центр взаимодействия компьютерных сетей «МСК-IX»',
                    'Contacts connect': 'Подключение и поддержка',
                    'Contacts press': 'Пресс-служба',
                    'Contacts administration': 'Администрация',

                    'Error message title': 'Что-то пошло не так',
                    'Error message confirm': 'Понятно',
                    'Success message close': 'Хорошо',

                    'Header menu support': 'Поддержка',
                    'SHORT_SECOND': 'с',
                    'Date': 'Дата',
                    'Time': 'Время',
                    'Start time': 'Время начала',
                    'End time': 'Время окончания',
                    'Demo': 'Демо',
                    'You have unsaved changes in content card. Continue?': 'У вас остались несохраненные изменения в карточке контента. Вы действительно хотите выйти?',
                    'You have unfinished uploads. Continue?': 'У вас остались незаконченные загрузки. Вы действительно хотите уйти?',
                    'Ordered': 'Заказано',
                    'rejected': 'Не договорились',
                    'Rejected': 'Не договорились',
                    'Granted': 'Одобрено',
                    'granted': 'Одобрено',
                    'unknown': 'Неизвестно',
                    'Unknown': 'Нет данных',
                    'Enter one-time code': 'Введите одноразовый код',
                    'Change subscriber status error': 'Ошибка изменения статуса потребителя',
                    'Back from view mode': 'Выйти из режима просмотра, как потребитель',
                    'Meta': 'Мета',
                    'Category': 'Категория',
                    'Territory': 'Территория',
                    'Type of rights': 'Тип прав',
                    'Who sees the card': 'Кто видит карточку',
                    'Accessibility mode': 'Выберите режим доступности',
                    'Accessibility mode for view': 'Режим доступности для просмотра',
                    'Accessibility mode for download': 'Режим доступности для скачивания',
                    'Approve card': 'Согласовать карточку',
                    'History of changes': 'История изменений',
                    'Creation': 'Создание',
                    'Change': 'Изменение',
                    'File deleted': 'Удалён файл',
                    'File upload': 'Загружен файл',
                    'Card status': 'Статус карточки',
                    'Unit': 'Карточка',
                    'Normal': 'Нормально',
                    'Draft': 'Черновик',
                    'Deleted': 'Удалено',
                    'Censored': 'Заблокировано',
                    'Agree': 'Согласование',
                    'Agreed': 'Согласен',
                    'Legal': 'Правовая информация',
                    'User agreement': 'Пользовательское соглашение',
                    'MSK-IX Personal Data Policy': 'Политика обработки персональных данных АО «ЦВКС «МСК-IX»',
                    'Personal Data Processing Consent Form': 'Согласие на обработку персональных данных',
                    'Legal Entity': 'Название организации',
                    'Firstname is required': 'Укажите имя',
                    'Lastname is required': 'Укажите фамилию',
                    'Company is required': 'Укажите название',
                    'Phone is required': 'Укажите номер телефона',
                    'Autofill': 'Заполните за меня',
                    'Exit': 'Выход',
                    'ContactTo': 'Связаться',
                    'CONTACT': 'Связаться',
                    'PROPOSAL': 'Дать КП',
                    'CONCLUDE': 'Заключить договор',
                    'WAIT': 'Подождать',
                    'DISCINSIDE': 'Обсудить внутри',
                    'LEntity': 'Юрлицо',
                    'Extend all permits': 'Продлить все разрешения',
                    'Contract with': 'Договор с',
                    'Contract between': 'Договор между',
                    'and': 'и',
                    'Delete file': 'Удаление файла',
                    'Delete cover': 'Удаление обложки',
                    'Upload file': 'Загрузка файла',
                    'Upload cover': 'Загрузка обложки',
                    'Reply': 'Ответить',
                    'Access': 'Доступ',
                    'Offers': 'Предложения',
                    'Name': 'Имя',
                    'Contact': 'Контакт',
                    'Individual Entrepreneur': 'ИП',
                    'Self-Employed': 'Самозанятый',
                    'Individual': 'Физическое лицо',
                    'Organization': 'Организация',
                    'Organizations': 'Организации',
                    'Contractor': 'Исполнитель',
                    'Dictionaries': 'Справочники',
                    'Record': 'Запись',
                    'Lastname': 'Фамилия',
                    'Partner': 'Партнер',
                    'Organization name': 'Название организации',
                    'Permission': 'Разрешение',
                    'Permissions': 'Разрешения',
                    'EXTERNAL': 'ВНЕШНЕЕ',
                    'Created': 'Создано',
                    'Updated': 'Изменено',
                    'Details': 'Детали',
                    'Account name': 'Название аккаунта',
                    'About': 'О нас',
                    'About service': 'Об услуге',
                    'About content': 'О контенте',
                    'group': 'группа',
                    'Group': 'Группа',
                    'Groups': 'Группы',
                    'Taxnum': 'ИНН',
                    'Contract with Mediabaza': 'Договор с медиабазой',
                    'Total bitrate': 'Общий битрейт',
                    'Bitrate': 'Битрейт',
                    'Port': 'Порт',
                    'port': 'порт',
                    'Backup source': 'Резервный источник',
                    'Monitoring': 'Мониторинг',
                    'Monitoring data': 'Данные мониторинга',
                    'My consumers': 'Мои потребители',
                    'My TV': 'Мои телесигналы',
                    'My access': 'Мой доступ',
                    'Choose a organization': 'Выберите организацию',
                    'Promotion': 'Акция',
                    'Promotions': 'Акции',
                    'Recipient': 'Получатель',
                    "To contract": "К договору",
                    'ISSUED': 'Выдано',
                    'Issue permission': 'Выдать разрешение',
                    'Permission to create keys has been sent': 'Разрешение на создание ключей отправлено',
                    'The permission has already been sent': 'Разрешение уже было отправлено',
                    'WORKING': 'На рассмотрении',
                    'REVOKED': 'Отозвано',
                    'EXPIRED': 'Срок действия истек',
                    'EXPIRES': 'Истекает',
                    'Validity period not specified': 'Не указан срок действия',
                    'Severity': 'Важность',
                    'Orientation': 'Ориентация',
                    'Forwarded': 'Переадресовано',
                    'Delete organization error': 'Ошибка удаления организации',
                    'Access denied': 'Доступ запрещен',
                    'Владельцы сайта': 'Владельцы сайта',
                    'Site owner': 'Владельцы сайта',
                    'Поставщик': 'Поставщик',
                    'Потребитель': 'Потребитель',
                    'Партнер': 'Партнер',
                    'Партнер модератор': 'Партнер модератор',
                    'Partner moderator': 'Партнер модератор',
                    'Partner source Medialogistika': 'Партнер источник Медиалогистика',
                    'Партнер источник Медиалогистика': 'Партнер источник Медиалогистика',
                    'Partner source': 'Партнер источник',
                    'Guest': 'Гость',
                    'No guest': 'Не гость',
                    'Lounge': 'Гостиная',
                    'Users without accounts': 'Учётные записи без аккаунта',
                    'Users not logined': 'Учётные записи без входа',
                    'Account owners not logined': 'Аккаунты с владельцами без входа',
                    'Accounts without agreement': 'Аккаунты без соглашения',
                    'Organizations without taxnum': 'Организации без ИНН',
                    'The service is not available in the selected tariff.': 'В выбранном тарифе услуга не доступна.',
                    'SeeTariffs': 'Посмотреть <1>тарифы<1>',
                    'SubsToTelegram': 'Подписаться на уведомления в <1>Telegram</1>',
                    'Notification date': 'Дата уведомления',
                    'Notification type': 'Тип уведомления',
                    'Urgent': 'Срочное',
                    'High': 'Важное',
                    'Low': 'Обычное',
                    'Notify date placeholder': 'Выберите дату',
                    'Specified in the request': 'Указано в запросе',
                    'day': 'день',
                    'days': 'дней',
                    'days2': 'дня',
                    'Absent': 'Отсутствует',
                    'Problem': 'Проблема',
                    'Warning': 'Предупреждение',
                    'Secret': 'Секрет',
                    'configured': 'настроен',
                    'not configured': 'не настроен',
                    'Without license': 'Без лицензии',
                    'Delete file': 'Удалить файл',
                    'Frame resolution': 'Разрешение кадра',
                    'Audio codec': 'Аудиокодек',
                    'Video codec': 'Видеокодек',
                    'Entire report': 'Отчет о качестве',
                    'Show CRC': 'Контрольные суммы',
                    'Show more': 'Показать ещё',
                    'By e-mail': 'По почте',
                    'In Telegram': 'В Telegram',
                    'Import from file': 'Импорт из файла',
                    'Estimated price': 'Ориентировочная стоимость',
                    'Price': 'Цена',
                    'Price negotiable': 'Цена договорная',
                    'Organization accounts': 'Аккаунты организации',
                    'Enter 2fa code': 'Введите код из приложения двухфакторной аутентификации',
                    'promotion': 'акция',
                    'event': 'мероприятие',
                    'advertising': 'реклама',
                    'other': 'разное',
                    'landing': 'лендинг',
                    'New ones first': 'Сначала новые',
                    'Nearest first': 'Сначала ближайшие',
                    'Subscribe to newsletter': 'Согласен получать информационные и маркетинговые уведомления',
                    'The page version is out of date and needs to be reloaded': 'Версия страницы устарела и нуждается в перезагрузке',
                    'Please confirm that you are over 18': 'Подтвердите что вам исполнилось 18',
                    'Are you sure you want to delete this file?': 'Вы уверены что хотите удалить этот файл?',
                    'Are you sure you want to delete this trailer?': 'Вы уверены что хотите удалить трейлер?',
                    'Are you sure you want to delete this cover?': 'Вы уверены что хотите удалить обложку?',
                    'Are you sure you want to delete this document?': 'Вы уверены что хотите удалить этот документ?',
                    'Are you sure you want to delete this request?': 'Вы уверены что хотите удалить эту заявку?',
                    'Are you sure you want to delete this organization?': 'Вы уверены что хотите удалить эту организацию?',
                    'Are you sure you want to unlock this content unit?': 'Вы уверены что хотите разблокировать эту единицу контента?',
                    'Are you sure you want to lock this content unit?': 'Вы уверены что хотите заблокировать эту единицу контента?',
                    'Are you sure you want to delete this content unit?': 'Вы уверены что хотите удалить эту единицу контента?',
                    'Are you sure you want to delete this service unit?': 'Вы уверены что хотите удалить эту услугу?',
                    'This link is invalid': 'Данная ссылка недействительна',
                    'Log out': 'Выйти',
                    'All registered': 'Все зарегистрированные пользователи',
                    'Not available': 'Недоступно',
                    'Select the quality and version of the TV signal': 'Выбрать качество и версию телесигнала',
                    'Show to unregistered users': 'Разрешить показывать незарегистрированным пользователям',
                    'Show on index page': 'Показывать на главной странице',
                    'Show on recommended': 'Показывать в рекомендованном',
                    'Two-factor authentication must be enabled to download': 'Для загрузки должна быть включена двухфакторная аутентификация',
                    'To use Disk, two-factor authentication must be enabled': 'Для работы с Мдиском должна быть включена двухфакторная аутентификация',
                    'The comment will be visible only to you': 'Комментарий будет виден только вам',
                    'ServiceAggreementMsg': 'Пожалуйста, подтвердите согласие с <1>пользовательским соглашением</1> для дальнейшей работы с ресурсами Медиабазы.',
                    'PDConsent': 'Пожалуйста, подтвердите <1>согласие на обработку персональных данных</1> для дальнейщей работы с ресурсами Медиабазы.',
                    'MMFeedback': 'Если вы не нашли название телеканала в этом справочнике, <br/> обратитесь в <1>поддержку</1>  для добавления.',
                    '2FAConfigureLink': 'Чтобы настроить перейдите по <1>ссылке</1>',
                    'Mediadaza will be temporarily unavailable due to a scheduled upgrade': 'Сайт временно недоступен в связи с обновлением',
                    'Consent to the processing of personal data': 'Согласие на обработку персональных данных',
                    'Agreement with the user agreement': 'Согласие с пользовательским соглашением',
                    '429_message': 'Сервер получил слишком много запросов за короткий промежуток времени и временно ограничил доступ для защиты от перегрузки',
                    'Try back later': 'Попробуйте вернуться позже',
                    'submit_a_request': 'Оставить заявку',
                    'participate': 'Участвовать',
                    'register': 'Зарегистрироваться',
                    'get_an_offer': 'Получить предложение',
                    'find_out_more': 'Узнать подробнее',
                    'go_to': 'Перейти',
                    'see': 'Смотреть',
                    'order': 'Заказать',
                    'connect': 'Подключить',
                    'contact': 'Связаться',
                    'get_a_consultation': 'Получить консультацию',
                    'if exists': 'если есть',
                    'Full name': 'ФИО',
                    'Action type': 'Тип действия',
                    ...mdx.ru,
                }
            }
        },
        fallbackLng: "en",
        debug: process.env.NODE_ENV !== 'production',

        // have a common namespace used around the full app
        ns: ["translations", 'modal', 'dashboard', 'profile'],
        defaultNS: "translations",

        // keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
